import type { PreviewCode } from './previewHttp';

/*
 * Die Einstiege ohne Kamera — dieselben Namen wie bei Ink (`preview`, `server`), damit Relay
 * für beide Apps denselben Link baut:
 *   Web:     https://<stage-web>/?preview=<id>&server=<Basis-URL, kodiert>
 *   Desktop: --preview=<id> --server=<Basis-URL>
 */

const code = (id: string | null | undefined, url: string | null | undefined): PreviewCode | null =>
  id && url ? { id: id.trim(), url: url.trim() } : null;

/** Aus der Adresse des Browsers, `location.search`. */
export function codeAusAdresse(search: string): PreviewCode | null {
  const p = new URLSearchParams(search);
  return code(p.get('preview'), p.get('server'));
}

/** Aus den Aufrufargumenten des Desktops (`process.argv`, auch beim Zweitaufruf). */
export function codeAusArgumenten(argv: readonly string[]): PreviewCode | null {
  const wert = (name: string) => argv.find((a) => a.startsWith(`--${name}=`))?.slice(name.length + 3);
  return code(wert('preview'), wert('server'));
}

/**
 * Hört auf Web-Adresse und Desktop-Aufruf — einmal beim Start, danach auf jeden Zweitaufruf.
 *
 * ⚠️ **Die Adresse wird sofort bereinigt** (`replaceState`): ein Neuladen holte die Preview
 * sonst noch einmal ab, und Message hat sie da schon gelöscht.
 */
export async function starteVorschauEinstiege(
  oeffne: (code: PreviewCode) => unknown,
  bruecke: { aufrufArgumente(): Promise<string[]>; aufZweitaufruf(h: (argv: string[]) => void): () => void } | null,
): Promise<void> {
  if (bruecke) {
    const erst = codeAusArgumenten(await bruecke.aufrufArgumente().catch(() => []));
    if (erst) void oeffne(erst);
    bruecke.aufZweitaufruf((argv) => {
      const neu = codeAusArgumenten(argv);
      if (neu) void oeffne(neu);
    });
    return;
  }
  const ausAdresse = codeAusAdresse(location.search);
  if (!ausAdresse) return;
  const ohne = new URLSearchParams(location.search);
  ohne.delete('preview');
  ohne.delete('server');
  const rest = ohne.toString();
  history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
  void oeffne(ausAdresse);
}
